"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAggregatedValuesProductLabelsFilter = exports.sortingItemToPropName = exports.sortingItemToLocalSortMap = exports.sortingItemToAggregatedValuesSortMap = exports.sortingItemToStrategyValuesSortMap = void 0;
const graphql_1 = require("../../../__generated__/graphql");
const models_1 = require("../../models");
const utils_1 = require("../../utils");
exports.sortingItemToStrategyValuesSortMap = {
    [models_1.SortingItem.SortByTextAsc]: [{ value: graphql_1.OrderBy.Asc }],
    [models_1.SortingItem.SortByTextDesc]: [{ value: graphql_1.OrderBy.Desc }],
    [models_1.SortingItem.SortByProductCountsAsc]: [{ value: graphql_1.OrderBy.Asc }],
    [models_1.SortingItem.SortByProductCountsDesc]: [{ value: graphql_1.OrderBy.Asc }],
};
exports.sortingItemToAggregatedValuesSortMap = {
    [models_1.SortingItem.SortByTextAsc]: { value: graphql_1.SortOrder.Asc },
    [models_1.SortingItem.SortByTextDesc]: { value: graphql_1.SortOrder.Desc },
    [models_1.SortingItem.SortByProductCountsAsc]: { productCount: graphql_1.SortOrder.Asc },
    [models_1.SortingItem.SortByProductCountsDesc]: { productCount: graphql_1.SortOrder.Desc },
};
exports.sortingItemToLocalSortMap = {
    [models_1.SortingItem.SortByTextAsc]: (0, utils_1.sortByTextFieldCaseInsensitive)(utils_1.SortOrder.Ascend),
    [models_1.SortingItem.SortByTextDesc]: (0, utils_1.sortByTextFieldCaseInsensitive)(utils_1.SortOrder.Descend),
    [models_1.SortingItem.SortByProductCountsAsc]: (0, utils_1.sortByNumberField)(utils_1.SortOrder.Ascend),
    [models_1.SortingItem.SortByProductCountsDesc]: (0, utils_1.sortByNumberField)(utils_1.SortOrder.Descend),
};
exports.sortingItemToPropName = {
    [models_1.SortingItem.SortByTextAsc]: 'value',
    [models_1.SortingItem.SortByTextDesc]: 'value',
    [models_1.SortingItem.SortByProductCountsAsc]: 'productCount',
    [models_1.SortingItem.SortByProductCountsDesc]: 'productCount',
};
const getAggregatedValuesProductLabelsFilter = (attributeName, options) => {
    const { includeOnlyValidValues = false } = options !== null && options !== void 0 ? options : {};
    return {
        label: {
            equals: attributeName,
        },
        isRequirement: includeOnlyValidValues,
        includeNA: true,
    };
};
exports.getAggregatedValuesProductLabelsFilter = getAggregatedValuesProductLabelsFilter;
